var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10776_27820",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10776_27820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 13.833V2.14967H6.21602C6.32713 1.76079 6.55224 1.44412 6.89135 1.19967C7.23002 0.95523 7.59935 0.833008 7.99935 0.833008C8.42157 0.833008 8.79935 0.95523 9.13268 1.19967C9.46601 1.44412 9.68824 1.76079 9.79935 2.14967H13.8493V7.46634H12.5993V3.39967H11.2327V5.31634H4.78268V3.39967H3.41602V12.583H6.79935V13.833H2.16602ZM11.9993 13.933L11.1327 13.0497L12.2327 11.9497H8.04935V10.6997H12.2327L11.1327 9.59967L11.9993 8.71634L14.616 11.333L11.9993 13.933ZM8.01602 3.33301C8.18268 3.33301 8.32713 3.2719 8.44935 3.14967C8.57157 3.02745 8.63268 2.87745 8.63268 2.69967C8.63268 2.53301 8.57157 2.38856 8.44935 2.26634C8.32713 2.14412 8.18268 2.08301 8.01602 2.08301C7.83824 2.08301 7.68824 2.14412 7.56602 2.26634C7.44379 2.38856 7.38268 2.53301 7.38268 2.69967C7.38268 2.87745 7.44379 3.02745 7.56602 3.14967C7.68824 3.2719 7.83824 3.33301 8.01602 3.33301Z",
    fill: "white",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtIcon);
export default __webpack_public_path__ + "static/media/сut-icon.625859fcd2a72ebcef29fbc2ee562592.svg";
export { ForwardRef as ReactComponent };